/*
 * @Author: liyxt
 * @Date: 2020-06-01 14:21:48
 * @LastEditors: liyxt
 * @LastEditTime: 2020-06-01 14:23:37
 * @Description: file content
 */ 
import { opaqueEncrypt } from './cipher';
import Cryptograph from './cryptograph';

// const cryptograph = new Cryptograph({ algorithmName: 'common' });

// const aeskey = cryptograph.getStaticSecretKey();

/**
 * 获取解密数据
 * @param {*string} data
 */
export function getDecryptData (data) {
    return localStorage.getItem('storeCipher') != '0' && data !== null ? opaqueEncrypt(data) : data;
}